import Vapi from 'vuex-rest-api';
import axios from '@/api/axios';

const store = new Vapi({
  axios,
  state: {
  },
})
  .get({
    action: 'getEdgeRequest',
    path: ({ requestId }) => `/edge/request/${requestId}`,
  })
  .getStore();

export default store;
